import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store';
import { getEntities as getProveedores } from './proveedor.reducer';
import Breadcrumb, { BreadcrumbItem } from '../commons/Breadcrumb';
import { FaHome } from '@react-icons/all-files/fa/FaHome';
import { FaUserShield } from '@react-icons/all-files/fa/FaUserShield';
import { FaBuilding } from '@react-icons/all-files/fa/FaBuilding';
import { FaIndustry } from '@react-icons/all-files/fa/FaIndustry';
import { FaTag } from '@react-icons/all-files/fa/FaTag';

function ManagerBreadcrumb() {
    const location = useLocation();
    const grupoEntity = useAppSelector(state => state.grupoEmpresarial.entity) as any;
    const empresas    = useAppSelector(state => state.grupoEmpresarial.empresas) as any[];

    const items: BreadcrumbItem[] = [
        { label: 'Inicio',  to: '/',        icon: <FaHome /> },
        { label: 'Empresas', to: '/empresas', icon: <FaUserShield /> },
    ];

    if (location.pathname.startsWith('/empresas/etiqueta')) {
        items.push({ label: 'Etiquetas', icon: <FaTag /> });
        return <Breadcrumb items={items} />;
    }

    const match = location.pathname.match(
        /\/empresas(?:\/grupo\/(\d+)(?:\/empresa\/(\d+))?)?/
    );
    const grupoId   = match?.[1];
    const empresaId = match?.[2];

    if (grupoId) {
        const grupoLabel = grupoEntity?.alias ?? `Grupo ${grupoId}`;
        items.push({
            label: grupoLabel,
            to: empresaId ? `/empresas/grupo/${grupoId}` : undefined,
            icon: <FaBuilding />,
        });
    }

    if (empresaId) {
        const empresa = empresas?.find((e: any) => String(e.id) === String(empresaId));
        const empresaLabel = empresa?.razonSocial ?? `Empresa ${empresaId}`;
        items.push({ label: empresaLabel, icon: <FaIndustry /> });
    }

    return <Breadcrumb items={items} />;
}

function Manager() {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getProveedores({ page: 0, size: 10000, sort: 'nombre,asc' }));
    }, [dispatch]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            <ManagerBreadcrumb />
            <Outlet />
        </div>
    );
}

export default Manager;
